<template>
  <v-dialog v-model="showUpgradeLicenceUserDialog" persistent max-width="520px">
    <div class="ec-dialog">
      <div class="ec-dialog__header">
        <div>
          <h2 class="ec-dialog__title">Upgrade Licence</h2>
          <p class="ec-hint" style="margin:2px 0 0">
            <span style="color:var(--ec-text-1);font-weight:600">{{ currentLicence.label }}</span>
            <span v-if="selectedLicenceKey"> → <span style="color:var(--ec-primary);font-weight:600">{{ selectedLicenceKey.licence_name }}</span></span>
          </p>
        </div>
        <button class="ec-icon-btn" @click="closeUpgradeLicenceDialog">
          <v-icon size="18">mdi-close</v-icon>
        </button>
      </div>

      <v-form lazy-validation v-model="form" ref="upgradeLicenceForm" :disable="loadingUpgradeDialog">
        <div class="ec-dialog__body">
          <div class="ec-field">
            <label class="ec-label">Select Licence *</label>
            <v-combobox
              v-model="selectedLicenceKey"
              :rules="[rules.required]"
              :items="licenceKeys"
              dense outlined hide-details="auto"
              return-object
              item-text="licence_name"
              single-line
              item-value="id"
              placeholder="Choose target licence…"
            />
          </div>

          <p v-if="selectedLicenceKey" class="ul-upgrade-note">
            This license will be upgraded to
            <strong>{{ selectedLicenceKey.licence_name }}</strong> with new usages.
          </p>
        </div>

        <div class="ec-dialog__footer">
          <button class="ec-btn ec-btn--ghost" type="button" @click="closeUpgradeLicenceDialog">Cancel</button>
          <button class="ec-btn ec-btn--primary" type="button"
                  :disabled="!form || loadingUpgradeDialog" @click="upgradeUserLicence">
            <v-progress-circular v-if="loadingUpgradeDialog" size="13" width="2" indeterminate style="margin-right:6px" />
            Upgrade
          </button>
        </div>
      </v-form>
    </div>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
export default {
  data () {
    return {
      rules: {
        required: (v) => !!v || 'This field is required'
      },
      selectedLicenceKey: null,
      form: true,
      loadingUpgradeDialog: false
    }
  },
  props: {
    showUpgradeLicenceUserDialog: { type: Boolean, required: true },
    licenceKeys: { type: Array, required: true },
    currentLicence: { type: Object, required: true }
  },
  methods: {
    closeUpgradeLicenceDialog () {
      this.$emit('closeUpgradeLicenceUserDialog')
      this.$refs.upgradeLicenceForm.reset()
    },
    async upgradeUserLicence () {
      if (this.$refs.upgradeLicenceForm.validate()) {
        this.form = false
        this.loadingUpgradeDialog = true
        const upgradeLicencePayload = {
          licenceId: this.selectedLicenceKey.id,
          userLicenceId: this.currentLicence.id
        }
        await apiService
          .post('admin-upgrade-user-licence', upgradeLicencePayload)
          .then(() => {
            this.loadingUpgradeDialog = false
            this.closeUpgradeLicenceDialog()
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error occurred while upgrade the license!',
              'error'
            )
          })
          .finally(() => {
            this.form = true
            this.loadingUpgradeDialog = false
          })
      }
    }
  }
}
</script>

<style scoped>
.ul-upgrade-note {
  margin: 4px 0 0;
  font-size: .8rem;
  color: var(--ec-text-3);
  background: var(--ec-success-bg);
  border: 1px solid #bbf7d0;
  border-radius: var(--ec-radius-sm);
  padding: 8px 12px;
}
.ul-upgrade-note strong { color: var(--ec-success); }
</style>
